export default "__VITE_ASSET__lv49U$Lq__"